<template>
  <div class="travel_card_layout">
    <!-- 活动标题 -->
    <div v-wechat-title="'超能打卡挑战-时光旅行社'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-travel' v-show='preloadingShow'></div>
    </transition>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>
    <Header
      v-if='true'
      :config='headerConfig'
      :isShowInfo='true'
      :isOnline='1' />
    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')">
      <div class="bg_box">
        <div class="bg_1"></div>
      </div>
      <div class="logo">
        <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
          <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/logo.png"/>
        </transition>
      </div>
      <div class="title">
        <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
          <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/title.png"/>
        </transition>
      </div>
      <div class="sub_title">
        <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
          <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/sub_title.png"/>
        </transition>
      </div>
      <div class="active_date" v-if="status !== 0">
        <p>本轮活动时间: {{activeTime}}</p>
      </div>
      <div :class="'rewards rewards_' + (userInfo.role_id ? gear : '')"></div>
      <div class="card">
        <img src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/card_border.png"/>
        <div :class="'avatar avatar_' + gear"></div>
        <div class="intro">
          <template v-if="userInfo.role_id">
            <p class="line_1">开拓者{{userInfo.role_name}}</p>
            <p class="line_2" v-if="gear === 0">当前您还未拥有超能卡</p>
            <p class="line_2" v-else-if="gearRefund">当前您的【{{ curCardName }}】未激活</p>
            <p class="line_2" v-else>
              当前您的超能卡为
              <span :class="'card_name card_name_' + gear">【{{ curCardName }}】</span>
            </p>
          </template>
          <p class="line_1" v-else>亲爱的开拓者，欢迎登录</p>
        </div>
      </div>
      <div class="detail_btn" @click="openDetailPopup()">
        <img src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/detail_btn.png"/>
      </div>

      <div class="operation_box">
        <div class="btn btn_1 refund_btn" @click="clickAllRefund()"></div>
        <div :class="'btn btn_2 ' + opBtn2Class" @click="onJoinUpgrade()">
          <p v-if="showRemainTime">本轮{{ (gear === 0 || gearRefund) ? '参与' : '升级' }}倒计时：{{ remainTime }}</p>
        </div>
      </div>
    </div>
    <Footer :gameName="gameName" />

    <!-- 活动详情 -->
    <div class="detail_wrap popup_wrap" v-if="detailShow">
      <div class="detail_box popup_wrap_box" v-show="detailShow" @click="closePopup('detailShow')">
        <div class="content">
          <img src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/popup/rule_detail.png" alt="规则详情">
        </div>
      </div>
      <div class="close-bg" v-show="detailShow" @click="closePopup('detailShow')"></div>
    </div>

    <!-- 首次参与须知 -->
    <div class="join_wrap popup_wrap" v-if="joinShow">
      <div class="join_box popup_wrap_box" v-if="joinShow">
        <div class="detail">
          <h5>开拓者{{userInfo.role_name}}，请仔细阅读以下规则。</h5>
          <p>1、30元将作为您参与本次活动的报名费，在参与活动期间，将为您永久保留；</p>
          <p>2、您在任意一期活动挑战成功后，可于当期【结算期】内前往活动页手动选择“全额返现金”，报名费将返还至您的付款账户中；</p>
          <p>3、若您在本轮未能挑战成功，系统将默认“投入下一轮打卡”，我们将保存您的挑战金，直到您在某轮打卡挑战成功后，可在当期进行操作返还。</p>
        </div>
        <p>
          <label>
            <input type="checkbox" ref="ruleBox" @click="clickRuleBox()" /> 我已知悉并同意以上规则
          </label>
        </p>
        <div :class="'confirm_btn ' + (agreeRule ? '' : 'disable')" @click="openPayPopup(1)"></div>
      </div>
      <div class="close-bg" v-show="joinShow" @click="closeJoinPopup()"></div>
    </div>

    <!-- 再次参与须知 -->
    <div class="join_again_wrap popup_wrap" v-if="joinAgainShow">
      <div class="join_again_box popup_wrap_box" v-if="joinAgainShow">
        <div class="detail">
          <h5>开拓者{{userInfo.role_name}}，请仔细阅读以下规则。</h5>
          <p>1、您已经拥有超能卡【{{curCardName}}】，再次参与活动的报名费为{{activeInfo.the_moeny}}元。在参与活动期间，将为您永久保留。</p>
          <p>2、您还可以选择点击下方按钮，升级超能卡参与活动。</p>
          <p>3、您在任意一期活动挑战成功后，可于当期【结算期】内前往活动页手动选择“全额返现金”，报名费将返还至您的付款账户中；</p>
          <p>4、若您在本轮未能挑战成功，系统将默认“投入下一轮打卡”，我们将保存您的挑战金，直到您在某轮打卡挑战成功后，可在当期进行操作返还。</p>
        </div>
        <p>
          <label>
            <input type="checkbox" ref="ruleBox" @click="clickRuleBox()" /> 我已知悉并同意以上规则
          </label>
        </p>
        <div :class="'join_again_btn ' + (agreeRule ? '' : 'disable')" @click="openPayPopup(1)"></div>
        <div :class="'upgrade_btn ' + (agreeRule ? '' : 'disable')" @click="openPayPopup(2)"></div>
      </div>
      <div class="close-bg" v-if="joinAgainShow" @click="closeJoinPopup()">
      </div>
    </div>

    <!-- 升级须知 -->
    <div class="upgrade_wrap popup_wrap" v-if="upgradeShow">
      <div class="upgrade_box popup_wrap_box" v-if="upgradeShow">
        <div class="detail">
          <h5>开拓者{{userInfo.role_name}}，请仔细阅读以下规则。</h5>
          <p>1、您将会追加一定数额的挑战金，作为参与本次升级超能卡后活动的报名费，在参与活动期间，将为您永久保留；</p>
          <p>2、您在任意一期活动挑战成功后，可于当期【结算期】内前往活动页手动选择“全额返现金”，报名费将返还至您的付款账户中；</p>
          <p>3、若您在升级后未能挑战成功，将无法升级超能卡，且系统默认将本期挑战金投入下一轮，且本轮结算期无法返还挑战金。</p>
          <p>升级后打卡可获得：</p>
        </div>
        <div :class="'reward_img reward_img_' + (gear + 1)"></div>
        <div class="agree_upgrade">
          <label>
            <input type="checkbox" ref="upgradeBox" @click="clickUpgradeBox()" /> 我已知悉并同意以上规则
          </label>
        </div>
        <div :class="'btn upgrade_btn ' + (agreeUpgrade ? '' : 'disable')" @click="openPayPopup(2)"></div>
      </div>
      <div class="close-bg" v-if="upgradeShow" @click="closeUpgradePopup()"></div>
    </div>

    <!-- 返还现金 -->
    <div class="refund_wrap popup_wrap" v-if="refundShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="refund_box popup_wrap_box" v-if="refundShow">
          <div class="detail">
            <p>恭喜您挑战成功！</p>
            <p>现在领取现金返还，<span>红点超人</span>将恢复初始形象，</p>
            <p><span>您可以继续本轮剩余天数的打卡，但将无法参与下一轮打卡活动哦~</span></p>
            <p>若想要再次参与活动，需要重新支付挑战金。</p>
            <p>现在升级超能卡，打卡可获取以下道具资源，真的不再考虑一下嘛？</p>
            <p>升级档位奖励展示:</p>
          </div>
          <div :class="'reward_img reward_img_' + (gear + 1)"></div>
          <div :class="'btn refund_btn ' + (isRefund ? '' : 'disable')" @click="onRefund()"></div>
          <div :class="'btn upgrade_btn ' + (isUpgrade ? '' : 'disable')" @click="onUpgradeByRefund()"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="refundShow" @click="closePopup('refundShow')"></div>
    </div>

    <!-- 退款提示 -->
    <div class="refund_tip_wrap popup_wrap" v-if="refundTipShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="refund_tip_box popup_wrap_box" v-if="refundTipShow">
          <div class="text">
            <p>您在本轮还未挑战成功</p>
          </div>
          <div :class="'refund_btn ' + (isRefund ? '' : 'disable')"></div>
          <div :class="'upgrade_btn ' + (isUpgrade ? '' : 'disable')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="refundTipShow" @click="closePopup('refundTipShow')"></div>
    </div>

    <!-- 退款成功提示 -->
    <div class="refund_success_wrap popup_wrap" v-if="refundSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="refund_success_box popup_wrap_box" v-if="refundSuccessShow">
          <div class="confirm_btn" @click="closePopup('refundSuccessShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="refundSuccessShow" @click="closePopup('refundSuccessShow')"></div>
    </div>

    <!-- 引导玩家解锁弹窗 -->
    <div class="guide_wrap popup_wrap" v-if="guideTips">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="guide_box popup_wrap_box" v-if="guideTips">
          <div class="confirm_btn" @click="closePopup('guideTips')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="guideTips" @click="closePopup('guideTips')"></div>
    </div>

    <!-- 未参与活动提示 -->
    <div class="join_tip_wrap popup_wrap" v-if="joinTipShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="join_tip_box popup_wrap_box" v-if="joinTipShow">
          <div class="detail_btn" @click="openDetailInTip()"></div>
          <div class="join_btn" @click="onJoinActiveInTip()"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="joinTipShow" @click="closePopup('joinTipShow')"></div>
    </div>

    <!-- 提示弹窗 -->
    <div class="tip_wrap popup_wrap" v-if="tipShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="tip_box popup_wrap_box" v-if="tipShow">
          <div class="text" v-html="tipHtml"></div>
          <div class="confirm_btn" @click="closePopup('tipShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="tipShow" @click="closePopup('tipShow')"></div>
    </div>

    <!-- 支付弹窗 -->
    <div class="pay_wrap popup_wrap" v-if="payShow">
      <!-- <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }"> -->
        <div :class="'pay_box pay_box_' + payShow" v-show="payShow">
          <h3>支付订单</h3>
          <div class="amount"><span>￥</span>{{(amount).toFixed(2)}}</div>
          <div class="pay_channel">
            <div class="wechat" v-if="isWechatBrowser" @click="selectPayWay(1)">
              <div class="icon">
                <img src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/popup/pay_wechat_icon.png" alt="微信支付">
              </div>
              <div class="info">
                <h4 class="name">微信支付</h4>
                <p>使用微信支付</p>
              </div>
              <div :class="'checkbox ' + (payWay === 1 ? 'active' : '')"></div>
            </div>

            <div class="alipay" v-else @click="selectPayWay(2)">
              <div class="icon">
                <img src="https://download4.qcplay.com/h5-images/active/travel/superPunchClock/popup/pay_ali_icon.png" alt="微信支付">
              </div>
              <div class="info">
                <h4 class="name">支付宝支付</h4>
                <p>使用支付宝支付</p>
              </div>
              <div :class="'checkbox ' + (payWay === 2 ? 'active' : '')"></div>
            </div>
          </div>
          <div :class="'confirm_pay ' + (payWay !== 0 ? 'active' : '')" @click="goToPay()">确认支付</div>
        </div>
      <!-- </transition> -->
      <div class="close-bg" v-show="payShow" @click="closePayPopup()"></div>
    </div>

    <!-- 支付提示弹窗 -->
    <div class="pay_tips_wrap popup_wrap" v-if="paymentTipsShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="pay_tips_box popup_wrap_box" v-if="paymentTipsShow">
          <div class="text">
            <p>请确认是否完成支付?</p>
          </div>
          <div class="btns">
            <a class="btn_1" @click="orderQuery(1)" href="javascript:;"></a>
            <a class="btn_2" @click="orderQuery(2)" href="javascript:;"></a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 升级成功提示 -->
    <div class="upgrade_success_wrap popup_wrap" v-if="upgradeSuccessShow">
      <div class="upgrade_success_box popup_wrap_box" v-if="upgradeSuccessShow">
        <div class="confirm_btn" @click="closePopup('upgradeSuccessShow')"></div>
      </div>
      <div class="close-bg" v-if="upgradeSuccessShow" @click="closePopup('upgradeSuccessShow')"></div>
    </div>

    <!-- 支付宝调用标签 -->
    <div id="aliPayBtn"></div>

    <!-- 支付成功 -->
    <div class="pay_success_wrap popup_wrap" v-if="paySuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="pay_success_box popup_wrap_box" v-if="paySuccessShow">
          <div class="confirm_btn" @click="closePopup('paySuccessShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="paySuccessShow" @click="closePopup('paySuccessShow')"></div>
    </div>
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>

</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { headerConfig } from '../headerConfig.js';
import { onGetInitDataAPI, onAutoLoginAPI, onPayAPI, onQueryOrderAPI, wechatInfoAPI, onRefundAPI, getCardInfoAPI } from '../api';
import { analysisParams, getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';

const card_list = ['白银卡', '黄金卡', '铂金卡', '钻石卡', '黑钻卡'];
const payList = [
  { name: '微信支付_wechatApp', payType: 'wechat', payMethod: 'mp' },
  { name: '微信支付_h5', payType: 'wechat', payMethod: 'wap' },
  { name: '支付宝支付', payType: 'alipay', payMethod: 'wap' },
];

export default {
  name: 'demo',
  components: {
    Header,
    Login,
    Os,
    Footer,
  },
  data () {
    return {
      headerConfig,
      gameName: 'travel',
      downloadUrl: 'https://sglxs.qingcitimes.com/',
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      payConfig: null, // 支付方式
      isSafari: false,

      detailShow: false,
      joinTipShow: false,
      joinShow: false,
      joinAgainShow: false, // 再次参与
      payShow: false,
      paySuccessShow: false, // 支付成功弹窗
      refundShow: false,   // 退款弹窗
      refundTipShow: false,
      upgradeShow: false,  // 升级超能卡
      tipShow: false,
      tipHtml: '',
      guideTips: false, // 引导玩家解锁的弹窗
      paymentTipsShow: false,
      refundSuccessShow: false,
      upgradeSuccessShow: false,

      agreeRule: false,
      agreeUpgrade: false,
      amount: 0,
      payWay: 0, // 0: 未选择  1： 微信支付  2：支付宝支付
      product: null, // 支付商品  0：本档   1：升级
      opBtn2Class: 'join_btn', // 第二个按钮的样式(参与|升级按钮)

      open_id: null,
      isRecharge: false, // 是否充值
      timer: null, // 倒计时
      gear: 0, // 档位  0-5   0表示未买卡
      gearRefund: false, // 参与过并且退款了
      status: 0, // 1：参与中  2: 进行中  3： 结算中
      isRefund: false, // 是否可以退款   0：不可以 1：可以
      isUpgrade: false, // 是否可以升级  0：不可以 1：可以
      activeTime: '请先登录',
      showRemainTime: false,
      remainTime: '',
      curCardName: '',
    };
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下
      this.payConfig = {
        1: { ...payList[0] }
      };
    } else {
      this.payConfig = {
        // 1: { ...payList[1] },
        2: { ...payList[2] }
      };
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }

    // 埋点
    const bl = buriedLogger('travel', '超能打卡挑战');
    this.logger = bl;

    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/travel/superPunchClock/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };

    // 解析query 是否免密登录
    const params = analysisParams(window.location.href);
    if (params.role_id && params.token) {
      onAutoLoginAPI({...params})
        .then((response) => {
          if (response.code !== 200) {
            // 记录错误
            bl.error({name:'免登录API错误', message:`params: ${JSON.stringify(params)}`});
          }
          reload();
        }).catch((err) => {
          // 记录错误
          bl.error({name:'免登录错误', message:`params: ${JSON.stringify(params)}`});
          reload();
        });
    } else {
      if (this.isWechatBrowser) {
        wechatInfoAPI().then((response) => {
          if (Number(response.code) == 200) {
            this.open_id = response.data.open_id;
            if (response.data.open_id == null) {
              window.location.href = '//api.qingcigame.com/wechat/get/open/?back=' + encodeURIComponent(window.location.href)
              return
            }
            this.getCardInfo();
          } else {
            bl.error({name:'微信授权信息错误', message:`详情: ${response.message}`});
            this.onToast(response.message);
            this.preloadingShow = false;
          }
        });
      } else {
        // 获取打卡信息
        this.getCardInfo();
      }
    }
    this.isSetShare();
  },
  mounted () {
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.clearActiveInfo();
        } else {
          // TAG: 初始登录/切换角色的时候/重新获取账户信息
          const { is_refund, current_gear, execution_time, countdown_time, 
            is_upgradation, status, gear_refund, is_echarge } = this.activeInfo;
          this.gear = current_gear;
          this.status = status;
          this.isRecharge = is_echarge;
          this.isRefund = is_refund;
          this.isUpgrade = !!is_upgradation;
          this.showRemainTime = status === 1;
          this.gearRefund = gear_refund;
          this.activeTime = execution_time;
          this.getRemainTime(countdown_time);
          this.curCardName = current_gear === 0 ? '' : card_list[current_gear - 1];

          // 测试数据
          // this.showRemainTime = true;
          // this.status = 3;
          // this.gear = 5;
          // this.gearRefund = true;
          // this.isRecharge = true;
          // this.isUpgrade = true;
          // this.isRefund = true;

          this.setOpBtn2Class();
        }
      }
    }
  },
  methods: {
    // 清除data里面相关数据
    clearActiveInfo() {
      this.clearRemainTime();
      this.gear = 0;
      this.gearRefund = false;
      this.status = 0;
      this.isRefund = false;
      this.isUpgrade = false;
      this.activeTime = '请先登录';
      this.showRemainTime = false;
      this.remainTime = '';
      this.curCardName = card_list[0];
      this.opBtn2Class = 'join_btn';
      this.product = null;
    },
    // 选择角色后
    selectCallback () {
      this.getCardInfo();
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {},
    closePopup (name) {
      this[name] = false;
      if (name === 'paySuccessShow') {
        onGetInitDataAPI().then(response => {
          this.onInitDataCallback(response);
        });
      }
    },
    openDetailPopup() {
      this.detailShow = true;
      this.logger.sum('详情按钮');
    },
    getCardInfo () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.preloadingShow = false;
        this.titleShow = true;
        if (response.code === 200) {
          getCardInfoAPI().then(() => {
            // 获取卡信息之后，还要重新获取一遍用户信息
            onGetInitDataAPI().then((res) => {
              this.onInitDataCallback(res);
            })
          });
        }
      });
    },
    // 倒计时
    getRemainTime(countdownTime) {
      this.clearRemainTime();
      if (!countdownTime) {
        return '';
      }
      const cTime = (new Date(countdownTime)).getTime();
      let unit = 1000;
      const countdown = () => {
        const nowDate = (new Date()).getTime();
        if (nowDate > cTime) {
          this.clearRemainTime();
          return false;
        }
        const seconds = Math.ceil((cTime - nowDate) / 1000);
        const days = Math.floor(seconds / (24 * 60 * 60));
        const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((seconds % (60 * 60)) / 60);
        const remainingSeconds = seconds % 60;

        let remainTime = `${days ? days + '天' : ''}${hours ? hours + '时' : ''}${minutes ? minutes + '分' : ''}`;
        if (!days) {
          remainTime = `${remainTime}${remainingSeconds}秒`;
        }
        this.remainTime = remainTime;
      };
      this.timer = setInterval(countdown, unit);
    },
    // 清除倒计时
    clearRemainTime() {
      clearInterval(this.timer);
      this.remainTime = '';
      this.timer = null;
    },
    setOpBtn2Class() {
      const { status, isRecharge } = this;
      let className = '';
      if (isRecharge) { // 已充值(退款属于未充值)
        className = 'upgrade_btn';
      } else if ([2, 3].includes(status)) { // 未充值 且 处于 进行中/结算期
        className = 'join_disable_btn';
      } else {
        className = 'join_btn';
      }
      this.opBtn2Class = className;
    },
    // 同意选择
    clickRuleBox() {
      const checked = this.$refs.ruleBox.checked;
      this.agreeRule = checked;
    },
    closeJoinPopup() {
      this.joinShow = false;
      this.joinAgainShow = false;
      this.$refs.ruleBox && (this.$refs.ruleBox.checked = false);
      this.agreeRule = false;
    },
    // 同意升级
    clickUpgradeBox() {
      const checked = this.$refs.upgradeBox.checked;
      this.agreeUpgrade = checked;
    },
    closeUpgradePopup() {
      this.upgradeShow = false;
      this.$refs.upgradeBox && (this.$refs.upgradeBox.checked = false);
      this.agreeUpgrade = false;
    },
    clickAllRefund() {
      // 未登录  未参与活动  未到结算期 未打满卡
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      if (this.status === 0) { // 未解锁
        this.guideTips = true;
        this.logger.sum('返现_未解锁');
        return false;
      }
      if (this.gear === 0 || this.gearRefund) { // 未参与过活动
        if ( this.status === 1) { // 报名期
          // 未参与提醒
          this.joinTipShow = true;
          this.logger.sum('返现_未参与提醒');
          return false;
        } else { // 未在报名期
          // 提示无法参与  可以在报名期参与
          this.tipHtml = '<p>当前无法进行参与，</p><p>您可以于报名期参与活动</p>';
          this.tipShow = true;
          this.logger.sum('返现_提示报名期参与');
          return false;
        }
      } else { // 已参与过游戏
        if (this.status !== 3 && this.gear !== 5) {
          // 不在结算期
          this.tipHtml = '<p>您可于结算期进行操作</p>';
          this.tipShow = true;
          this.logger.sum('返现_不在结算期');
          return false;
        } else if (this.isRefund) { // 结算期 + 可以退款
          // 退款弹窗
          this.refundShow = true;
          this.logger.sum('返现_退款弹窗');
          return false;
        } else { // 结算期 + 不可退款
          // 本轮未挑战成功
          this.refundTipShow = true;
          this.logger.sum('返现_本轮未挑战成功');
          return false;
        }
      }

    },
    selectPayWay(id) {
      if (this.payWay === id) {
        return false;
      }
      this.payWay = id;
    },
    openDetailInTip() {
      this.joinTipShow = false;
      this.detailShow = true;
      this.logger.sum('退款提示弹窗_详情');
    },
    onJoinActiveInTip() {
      this.joinTipShow = false;
      if (this.gear === 0 && this.status === 1) { // 打开首次参与
        this.joinShow = true;
        this.logger.sum('退款提示弹窗_首次参与');
      } else if (this.status === 1 && this.gearRefund) { // 打开再次参与
        this.joinAgainShow = true;
        this.logger.sum('退款提示弹窗_打开再次参与');
      }
    },
    // 参与或者升级
    onJoinUpgrade() {
      // 未登录
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      const { status, gearRefund, gear, isRecharge } = this;

      if (status === 0) { // 未解锁
        this.guideTips = true;
        this.logger.sum('参与按钮_未解锁');
        return false;
      }

      if (isRecharge) { // 升级按钮
        if (this.gear === 5) {
          this.tipHtml = '<p>您已经是最尊贵的黑钻卡</p><p>开拓者了，暂时无法升级</p>';
          this.tipShow = true;
          return false;
        }
        if (this.isUpgrade === false) {
          this.tipHtml = '<p>您在当前档位还没有打卡</p><p>成功哦，继续努力吧</p>';
          this.tipShow = true;
          this.logger.sum('升级按钮_未打卡成功');
          return false;
        }
        this.upgradeShow = true;
      } else { // 参与按钮
        if ([2, 3].includes(status)) { // 非报名期 无法参与
          this.tipHtml = '<p>当前无法进行参与，</p><p>您可以于报名期参与活动</p>';
          this.tipShow = true;
          this.logger.sum('参与按钮_无法参与[非报名期]');
          return false;
        }
        if (gear === 0 && status === 1) { // 首次报名
          this.logger.sum('参与按钮_首次报名');
          this.joinShow = true;
          return false;
        }
        if (status === 1 && gearRefund) {  // 再次报名
          this.joinAgainShow = true;
          this.logger.sum('参与按钮_再次报名');
          return false;
        }
      }
      
    },
    onRefund() {
      if (!this.isRefund) {
        return false;
      }
      this.preventShow = true;
      onRefundAPI().then(() => {
        this.preventShow = false;
        this.refundShow = false;
        this.refundSuccessShow = true;
        onGetInitDataAPI().then(response => {
          this.onInitDataCallback(response);
        });
      }).catch(() => {
        this.preventShow = false;
      });
      this.logger.sum('退款提示弹窗_返现按钮');
    },
    onUpgradeByRefund() {
      if (!this.isUpgrade) {
        return false;
      }
      this.refundShow = false;
      if (this.gear === 5) {
        this.tipHtml = '<p>您已经是最尊贵的黑钻卡</p><p>开拓者了，暂时无法升级</p>';
        this.tipShow = true;
      } else {
        this.upgradeShow = true;
      }
      this.logger.sum('退款提示弹窗_升级按钮');
    },
    openPayPopup(type) { // 1: 参与活动  2： 升级卡
      if (!this.agreeUpgrade && !this.agreeRule) {
        this.onToast('请勾选 "我已知悉"')
        return false;
      }
      this.logger.sum(`打开支付弹窗_${type === 1 ? '参与活动' : '升级卡'}`);
      if (type === 1) {
        this.amount = this.activeInfo.the_moeny;
        this.product = 0; // 本档
        this.closeJoinPopup();
      } else if (type === 2) {
        if (this.gear === 5) {
          this.tipHtml = '<p>您已经是最尊贵的黑钻卡</p><p>开拓者了，暂时无法升级</p>';
          this.tipShow = true;
          return false;
        } else if (this.isUpgrade === false) {
          this.tipHtml = '<p>您在当前档位还没有打卡</p><p>成功哦，继续努力吧</p>';
          this.tipShow = true;
          return false;
        }
        this.amount = this.activeInfo.next_moeny;
        this.refundShow = false;
        this.product = 1; // 升级
        this.closeJoinPopup();
        this.closeUpgradePopup();
      }
      if (this.isWechatBrowser) {
        this.payWay = 1;
      } else {
        this.payWay = 2;
      }
      this.payShow = true;
    },
    closePayPopup() {
      this.payWay = 0;
      this.amount = 0;
      this.payShow = false;
    },
    // 立即支付
    goToPay () {
      if (this.payWay === 0) {
        return false;
      }
      if (this.product === null) {
        this.onToast('product参数错误');
        return false;
      }
      this.preventShow = true;
      // this.payWay 1 微信  2 支付宝
      const curPay = this.payConfig[this.payWay];
      onPayAPI({ pay_type: curPay.payType, pay_method: curPay.payMethod, open_id: this.open_id, status: this.product })
        .then((response) => {
          if (Number(response.code) == 200) {
            this.order = response.data.order;
            this.paymentTipsShow = true;
            if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
              // 微信发送支付
              if (curPay.payType == 'wechat') {
                if (curPay.payMethod == 'mp') {
                  wx.chooseWXPay({
                    timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                    nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                    package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    signType: response.data.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                    paySign: response.data.data.paySign, // 支付签名
                    success: function (res) {
                      // 支付成功后的回调函数
                      setTimeout(() => { this.preventShow = false }, 1000)
                    },
                    fail: function (res) {
                      setTimeout(() => { this.preventShow = false }, 1000)
                    }
                  })
                  setTimeout(() => { this.preventShow = false }, 2000)
                } else {
                  if (response.data.data !== '') {
                    window.location.href = response.data.data
                    setTimeout(() => { this.preventShow = false }, 1000)
                  }
                }
              } else if (response.data.data !== '') {
                document.getElementById('aliPayBtn').innerHTML = response.data.data
                document.forms['alipaysubmit'].submit()
                setTimeout(() => { this.preventShow = false }, 1000)
              }
            }
            this.logger.sum('点击立即支付按钮');
            this.payShow = false;
            return
          }
          this.onToast(response.message);
          setTimeout(() => { this.preventShow = false }, 500);
        }).catch(() => {
          this.preventShow = false;
        });
    },
    orderQuery (type) {
      this.paymentTipsShow = false;
      // 订单轮询
      type == 1 ? this.wait = 15 : this.wait = 2;
      this.orderLoop(type);
      this.logger.sum(`订单轮询_${type === 1 ? '已完成订单' : '未完成订单'}`);
    },
    // 订单轮询
    orderLoop (i) {
      if (this.wait > 0) {
        this.onPayment(i)
        this.wait--;
        this.preventShow = true;
        Indicator.open()
        setTimeout(() => { this.orderLoop(i); }, 1500);
      } else {
        this.preventShow = false;
      }
    },
    onPayment (i) {
      onQueryOrderAPI({trade_no: this.order})
      .then((response) => {
        if (Number(response.code) === 200) {
          // 支付成功
          this.wait = 0;
          if (i == 1) this.onToast(response.message);
          this.paymentShow = false; // 关闭支付弹窗
          this.preventShow = false;
          if (this.product === 1) { // 升级成功弹窗
            this.upgradeSuccessShow = true;
          } else {
            this.paySuccessShow = true;
          }
          Indicator.close();
          onGetInitDataAPI().then(res => {
            this.onInitDataCallback(res);
          });
          return;
        } else {
          if (this.wait == 0) {
            if (i == 1) this.onToast(response.message);
            Indicator.close();
            onGetInitDataAPI().then(res => {
              this.onInitDataCallback(res);
            });
          }
        }
      });
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/travel/superPunchClock/enter${getRandomString()}`,
        title: '时光旅行社丨超能打卡挑战开启！',
        imgUrl: 'https://download4.qcplay.com/qcgame-admin/94eydHZRdJNac5GL7NJVNURLCO1uFRskSnmLIU47.png',
        desc: '超多资源送上！打卡成功可全额返现金~'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/travel/superPunchClock/index/index.vue